import React, { useEffect, useState } from "react";
import API from "../axiosInstance";
import "../styles/Safe.css";

export default function SoldePage() {
  const [coins, setCoins] = useState(0);

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  useEffect(() => {
    if (!currentUser?.email) return;

    API.get(`/coins/balance/${encodeURIComponent(currentUser.email)}`)
      .then((res) => {
        setCoins(Number(res.data?.coins_balance || 0));
      })
      .catch((err) => {
        console.error("❌ Erreur chargement solde :", err);
        setCoins(0);
      });
  }, [currentUser?.email]);

  return (
    <div className="solde-page">
      <div className="safe-wrapper">
        <div className="safe">
          <div className="safe-frame"></div>

          <div className="safe-interior">
            <div className="coin c1"></div>
            <div className="coin c2"></div>
            <div className="coin c3"></div>
            <div className="coin c4"></div>
            <div className="coin c5"></div>
            <div className="coin c6"></div>
            <div className="coin c7"></div>
            <div className="coin c8"></div>
            <div className="coin c9"></div>
            <div className="coin c10"></div>
            <div className="coin c11"></div>
            <div className="coin c12"></div>
            <div className="coin c13"></div>
            <div className="coin c14"></div>
            <div className="coin c15"></div>
            <div className="coin c16"></div>
            <div className="coin c17"></div>
            <div className="coin c18"></div>
            <div className="coin c19"></div>
            <div className="coin c20"></div>
          </div>

          <div className="safe-door">
            <div className="door-front">
              <div className="wheel"></div>
            </div>
          </div>
        </div>
      </div>

      <h2 className="solde-title">
        💰 Votre solde : <span>{coins}</span> Coins
      </h2>
    </div>
  );
}
